'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Button = _interopDefault(require('@material-ui/core/Button'));
var styledComponents = require('../styled-components.js');
var utils = require('../utils.js');
var styledComponents$1 = require('./styled-components.js');

var AvatarWithSubtitle = function (props) {
    var classes = styledComponents.useStyles();
    var onClick = props.onClick, name = props.name, ariaControls = props.ariaControls, hasPopUp = props.hasPopUp, src = props.src, subtitle = props.subtitle, maxWidth = props.maxWidth, buttonStyle = props.buttonStyle;
    var avatar = utils.getAvatar(src, name, classes);
    return (React__default.createElement(styledComponents$1.Container, null,
        React__default.createElement(Button, { "aria-controls": ariaControls, "aria-haspopup": hasPopUp, startIcon: avatar, style: styledComponents.buttonOverrides(buttonStyle), variant: 'contained', color: 'primary', onClick: onClick },
            React__default.createElement(styledComponents$1.Main, { width: maxWidth },
                React__default.createElement(styledComponents$1.StyledH3, { "data-testid": 'avatar-name' }, name),
                subtitle && React__default.createElement(styledComponents$1.StyledP, { "data-testid": 'avatar-subtitle' }, subtitle)))));
};

module.exports = AvatarWithSubtitle;
